import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { LinkButton } from '../ui/Button';
import { useAdminData } from '../../contexts/AdminDataContext';
import { CONTACT_EMAIL, company } from '../../data/site';
import { telHref } from '../../utils/format';
const ease = [0.23, 1, 0.32, 1] as const;
const tagline = ['Multiservice', 'Montage', 'Vedligehold'];
export function Hero() {
  const {
    settings
  } = useAdminData();
  return <section id="top" className="scroll-mt-24" data-id="element-309" data-mp="qvduuzg45t10">
      <div className="bg-white" data-id="element-310" data-mp="qu2rh0qkynaf">
        <div className="mx-auto grid max-w-content items-center gap-10 px-5 py-14 md:py-20 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:px-8" data-id="element-311" data-mp="vmccq3gr2z6d">
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.45,
          ease
        }} className="flex justify-center lg:justify-start" data-id="element-312" data-mp="10kdtghqpemeo">
            <h1 data-id="element-313" data-mp="1ahilgy78dc3e">
              <img src={company.logo} alt={`${settings.companyName} — multiservice, håndværk og vedligehold`} className="h-44 w-auto max-w-full sm:h-52 md:h-64 lg:h-72" data-id="element-314" data-mp="9nt0q07lunif" />
            </h1>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45,
          ease,
          delay: 0.08
        }} data-id="element-315" data-mp="3vvap2655k1an">
            <ul className="flex flex-wrap items-center gap-x-4 gap-y-2 font-display text-lg font-bold tracking-tight text-ink md:text-2xl" data-id="element-316" data-mp="sdslwc0brigk">
              {tagline.map((item, index) => <li key={item} className="flex items-center gap-4" data-id="element-317" data-mp="in6a6svqbc35" data-mpi={index}>
                  {index > 0 && <span className="h-1.5 w-1.5 rounded-full bg-accent" aria-hidden="true" data-id="element-318" data-mp="enp17ph3fwt8" />}
                  {item}
                </li>)}
            </ul>

            <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-soft md:text-xl" data-id="element-319" data-mp="16ebq181o64dg">
              Praktiske løsninger til private og virksomheder. Har du en opgave, stor eller lille, så kontakt
              LYKKEVÆRK og få en uforpligtende snak.
            </p>

            <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-320" data-mp="35n37wc8f068c">
              <LinkButton href="#kontakt" size="lg" data-id="element-321" data-mp="2qvciiwin5oij">
                Få et tilbud
              </LinkButton>
              <LinkButton href={telHref(settings.phone)} variant="secondary" size="lg" data-id="element-322" data-mp="2vtmeh9c6wt57">
                Kontakt LYKKEVÆRK
              </LinkButton>
            </div>
          </motion.div>
        </div>
      </div>

      <div className="bg-ink" data-id="element-323" data-mp="2mvtzk6adrnic">
        <div className="mx-auto flex max-w-content flex-col gap-5 px-5 py-7 md:flex-row md:items-center md:justify-between md:py-8 lg:px-8" data-id="element-324" data-mp="27x9rkc6j9hi3">
          {settings.phone && <a href={telHref(settings.phone)} className="flex items-center gap-3 font-display text-2xl font-bold tracking-tight text-white transition-colors duration-200 ease-smooth hover:text-accent md:text-3xl" data-id="element-325" data-mp="2cyfji7sdd0qk">
              <PhoneIcon className="h-5 w-5 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-326" data-mp="1vo278d7gp7n1" />
              {settings.phone}
            </a>}

          <div className="flex flex-col gap-3 text-[15px] text-white/80 sm:flex-row sm:items-center sm:gap-8" data-id="element-327" data-mp="25cttq5tr6zqk">
            <a href={`mailto:${CONTACT_EMAIL}`} className="flex items-center gap-2.5 break-all transition-colors duration-200 ease-smooth hover:text-white" data-id="element-328" data-mp="20lljj7klnacc">
              <MailIcon className="h-4 w-4 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-329" data-mp="2acg6ke5o6dyu" />
              {CONTACT_EMAIL}
            </a>
            <p className="flex items-center gap-2.5" data-id="element-330" data-mp="2oawoz2cw9swt">
              <ClockIcon className="h-4 w-4 shrink-0 text-accent" strokeWidth={1.75} aria-hidden="true" data-id="element-331" data-mp="2jc3c9c5fm5xp" />
              Svar normalt samme dag
            </p>
            <p className="text-white/50" data-id="element-332" data-mp="tzrf3gb7sk91">CVR: {settings.cvr}</p>
          </div>
        </div>
      </div>
    </section>;
}